export default "__VITE_ASSET__DVOCLl7B__"